import './contact-form.scss';

import axios from 'axios';
import { createElementFromHTML } from './../../utilities/js/helper';

class ContactForm {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-contactform'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$contactForm = $element;
        this.$contactFormTypeSelect = this.$contactForm.querySelector('[' + this.settings.initAttr + '="typeselect"]');
        this.$contactFormTypeTarget = this.$contactForm.querySelector('[' + this.settings.initAttr + '="typetarget"]');
        this.$loadingSpinner = createElementFromHTML(window.OPTIONS.loader);

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        if (this.$contactFormTypeSelect && this.$contactFormTypeTarget) {
            this.$contactFormTypeSelect.addEventListener('change', () => {
                const targetUri = this.$contactFormTypeSelect.value;

                if (typeof targetUri !== 'undefined' && targetUri !== null) {
                    this.loadTargetUri(targetUri);
                }
            });
        }
    }

    loadTargetUri (uri) {
        this.$contactFormTypeTarget.appendChild(this.$loadingSpinner);

        axios({
            method: 'GET',
            url: uri,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((result) => {
                if (result && result.data) {
                    const $result = createElementFromHTML(result.data);

                    const $resultContent = $result.innerHTML;
                    if ($resultContent) {
                        this.$contactFormTypeTarget.innerHTML = $resultContent;
                    }

                    const contentUpdateEvent = new CustomEvent('content.loaded', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: this.$contactFormTypeTarget
                        }
                    });
                    window.dispatchEvent(contentUpdateEvent);

                    window.checkInview(window.eventScroller);
                }
            })
            .catch((error) => {
                throw Error(error);
            });
    }
}

export { ContactForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$contactForm = $context.querySelectorAll('[data-contactform="root"]');
        for (let i = 0; i < $$contactForm.length; i++) {
            const $contactForm = $$contactForm[i];

            const contactFormAPI = new ContactForm($contactForm);
            $contactForm.API = contactFormAPI;
        }
    }
});
